/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParcelFilterDto } from './parcelFilterDto.model';


export interface ParcelGroupCreateDto { 
    exceptParIds?: Array<number>;
    groupName?: string;
    parIds?: Array<number>;
    parcelFilter?: ParcelFilterDto;
    parcelGroupIds?: Array<number>;
    selectedAll?: boolean;
}

